
import { lopActions } from "./lopActions";
import { ngayNghiActions } from "./ngayNghiActions";
import { trangThaiDangKyAnActions } from "./trangThaiDangKyAnActions";

export const danhMucActionsWrapper = {
    lop: lopActions,
    ngayNghi: ngayNghiActions,
    trangThaiDangKyAn: trangThaiDangKyAnActions,
    
}